'use es6';

import { createSelector } from 'reselect';
import { OrderedMap, Set as ImmutableSet } from 'immutable';
import { AudienceTypes } from 'AdsUI/lib/Constants';
export const getAudiences = state => state.audiences.audiences;
export const getInactiveAudiences = state => state.audiences.inactiveAudiences;
export const getRawAccountFilter = state => state.audiences.accountFilter;
export const getPixels = state => state.audiences.pixels;
export const getSupportedAudiences = state => state.audiences.supported;
export const getAudienceCounts = state => state.audiences.usageInfo.get('audienceCounts');
export const getMembershipCountsMap = state => state.audiences.membershipCounts;
export const getAudiencesRequestStatus = state => state.requestStatus.audiences;
export const getSupportedAudiencesRequestStatus = state => state.requestStatus.supportedAudiences;
export const getSavedAudiencesRequestStatus = state => state.requestStatus.savedAudiences;
export const getMembershipCountsRequestStatusMap = state => state.requestStatus.membershipCounts;
export const getParentAudiences = createSelector(getAudiences, audiences => audiences.valueSeq().filter(audience => audience.type !== AudienceTypes.LOOKALIKE).toList());
export const getParentInactiveAudiences = createSelector(getInactiveAudiences, audiences => audiences.valueSeq().filter(audience => audience.type !== AudienceTypes.LOOKALIKE).toList());
export const getInstalledPixels = createSelector(getPixels, pixels => pixels.filter(pixel => pixel.installed));
export const getInstalledPixelsByNetwork = createSelector(getInstalledPixels, installedPixels => {
  return installedPixels.reduce((pixelsByNetwork, pixel) => {
    const network = pixel.adNetwork;

    if (!pixelsByNetwork.has(network)) {
      return pixelsByNetwork.set(network, ImmutableSet([pixel]));
    } else {
      return pixelsByNetwork.updateIn([network], pixels => pixels.add(pixel));
    }
  }, OrderedMap());
});
export const getContactListAudiences = createSelector(getAudiences, audiences => audiences.valueSeq().filter(audience => audience.type === AudienceTypes.CONTACT_LIST).toList());